import { Controller } from "@hotwired/stimulus";
import * as React from "react";
import type { Root } from "react-dom/client";
import reactRenderer from "~/lib/reactRenderer";
import TokenCodeInput from "~/components/shared/TokenCodeInput";

export default class extends Controller {
  static targets = ["input", "container"];
  static values = {
    errors: { type: Array, default: [] },
  };

  declare inputTarget: HTMLInputElement;
  declare containerTarget: HTMLElement;
  declare errorsValue: string[];

  private currentValue = "";
  private root: Root | undefined;

  connect() {
    this.renderComponent();
  }

  disconnect() {
    this.root?.unmount();
  }

  renderComponent() {
    this.root = reactRenderer(
      React.createElement(TokenCodeInput, {
        maxLength: 6,
        value: this.currentValue,
        errors: this.errorsValue,
        onChange: this.handleChange,
      }),
      this.containerTarget,
      this.root,
    );
  }

  handleChange = (value: string) => {
    this.currentValue = value;
    this.inputTarget.value = value;
    this.renderComponent();
  };
}
